import { useState, useEffect } from "react";

interface HeaderProps {
  onOpenForm: () => void;
}

export default function Header({ onOpenForm }: HeaderProps) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 80);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/50"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo & Title */}
          <div className="flex items-center gap-3">
            <button
              onClick={scrollToTop}
              className="flex items-center gap-3 cursor-pointer"
            >
              <div className="flex flex-col">
                <span
                  className={`text-sm md:text-base font-bold tracking-tight transition-colors ${
                    scrolled ? "text-foreground-900" : "text-white"
                  }`}
                >
                  파주 헤이리 오베르원
                </span>
              </div>
            </button>
          </div>

          {/* CTA Buttons */}
          <div className="flex items-center gap-2 md:gap-3">
            <button
              onClick={onOpenForm}
              className={`px-3 md:px-5 py-2 rounded-md text-xs md:text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                scrolled
                  ? "bg-primary-500 text-white hover:bg-primary-600"
                  : "bg-white/20 text-white hover:bg-white/30 backdrop-blur-sm border border-white/30"
              }`}
            >
              상담문의
            </button>
            <a
              href="tel:1877-4896"
              className={`flex items-center gap-1.5 px-3 md:px-5 py-2 rounded-md text-xs md:text-sm font-bold transition-all cursor-pointer whitespace-nowrap ${
                scrolled
                  ? "bg-primary-500 text-white hover:bg-primary-600"
                  : "bg-white/20 text-white hover:bg-white/30 backdrop-blur-sm border border-white/30"
              }`}
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-line text-xs"></i>
              </span>
              <span className="hidden md:inline">1877-4896</span>
              <span className="md:hidden">전화</span>
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}